import React, { useState } from "react"
import { Col, Form, Button } from "react-bootstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import isEmpty from "lodash/isEmpty"
import AutoComplete from "./AutoComplete"
import { faEnvelope } from "@fortawesome/pro-light-svg-icons"
import { Edit } from "lucide-react"
import { EditCaseNote } from "@components/CasesNew/EditCaseNote"
import { Tooltip, TooltipContent, TooltipTrigger } from "@components/ui/tooltip"
import { useAuthUserDetails } from "@apis/users/useUsers"
import { format, parseISO } from "date-fns"

const CaseNotes = ({
  caseDetails,
  caseNote,
  setCaseNote,
  handleSaveCaseNote,
  reloadCase
}) => {
  const { data: userData } = useAuthUserDetails()
  const [editingNote, setEditingNote] = useState(false)

  const displayCaseNotes = () => {
    if (!isEmpty(caseDetails.notes)) {
      return caseDetails.notes?.map((note, index) => {
        return (
          <>
            <div
              key={index}
              className="alert alert-info tw:p-2 tw:flex tw:justify-between tw:gap-3"
            >
              <p className="m-2 tw:flex-1">
                {note.requestor_notified && (
                  <FontAwesomeIcon
                    size="sm"
                    className="me-1"
                    color="#E86371"
                    icon={faEnvelope}
                    fixedWidth
                  />
                )}
                <b>
                  {note.first_name} {note.last_name}:{" "}
                </b>{" "}
                {note.note}
              </p>
              <Tooltip>
                <TooltipTrigger asChild>
                  <p className="m-2 tw:cursor-default">
                    {format(parseISO(note.note_dt), "MM/dd/yyyy")}
                  </p>
                </TooltipTrigger>
                <TooltipContent side="bottom">
                  <span>{format(parseISO(note.note_dt), "M/d/yyyy h:mm a")}</span>
                </TooltipContent>
              </Tooltip>
              {!note.note.includes("Description edited") &&
                note.user_id === userData.user_id && (
                  <Edit size={16} onClick={() => setEditingNote(true)} />
                )}
            </div>
            {editingNote && <EditCaseNote setEditingNote={setEditingNote} reloadCase={reloadCase} caseNote={note} />}
          </>
        )
      })
    } else {
      return <p>No notes for case</p>
    }
  }

  return (
    <Col>
      {displayCaseNotes()}
      <Form>
        <AutoComplete
          data-testid="case_note_input"
          name="case_note"
          rows={2}
          onChange={(e) => setCaseNote(e.target.value)}
          value={caseNote}
        />
        <Button onClick={() => handleSaveCaseNote()}>Save Note</Button>
      </Form>
    </Col>
  )
}

export default CaseNotes
